module.exports = "<img src=\"assets/images/dual-ring-loader.svg\" [ngClass]=\"class\">\n<span class=\"subscriber_loading_text\"> Waiting... </span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tokbox/components/loading/loading.component.html
// module id = ./src/app/tokbox/components/loading/loading.component.html
// module chunks = main